import * as React from "react"
import type { SVGProps } from "react"
const SvgRoute = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M19 21.29a3 3 0 0 1-1.75-.57 3 3 0 0 1-1.07-1.43H11q-1.65 0-2.82-1.18Q7 16.94 7 15.3c0-1.65.4-2.05 1.18-2.83A4 4 0 0 1 11 11.3h2q.83 0 1.41-.6.6-.57.59-1.4 0-.83-.59-1.42A2 2 0 0 0 13 7.3H7.83a3 3 0 0 1-1.1 1.43A3 3 0 0 1 5 9.3a3 3 0 0 1-2.12-.88A3 3 0 0 1 2 6.3q0-1.26.88-2.13A3 3 0 0 1 5 3.3q.98 0 1.74.56.75.55 1.09 1.44H13q1.65 0 2.83 1.17Q17 7.63 17 9.3c0 1.66-.4 2.04-1.17 2.82A4 4 0 0 1 13 13.3h-2q-.82 0-1.41.58A2 2 0 0 0 9 15.3q0 .83.59 1.4.58.6 1.41.6h5.18a3 3 0 0 1 1.08-1.44A3 3 0 0 1 19 15.3q1.24 0 2.13.87.87.88.87 2.13t-.87 2.12a3 3 0 0 1-2.13.88M5 7.3q.42 0 .71-.3A1 1 0 0 0 6 6.3a1 1 0 0 0-.29-.72A1 1 0 0 0 5 5.3a1 1 0 0 0-.71.28A1 1 0 0 0 4 6.3q0 .43.29.7.29.3.71.3" />
  </svg>
)
export default SvgRoute
